/**
 * @desc 批量删除
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: Array<number>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/corpsInfo/delete`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
